<template>
  <div class="Pon-Popup">
    <div class="Pon-Popup__header" :style="{ backgroundImage: `url('${data.logo}')` }">
      <div class="Pon-Popup__price">
        <span class="Pon-Popup__usd">$ {{ data?.nft_data?.floor_price_usd?.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}</span>
        <span class="Pon-Popup__percent" :class="data?.nft_data?.change_1d_percent < 0 ? 'Pon-Popup__percent--red' : 'Pon-Popup__percent--green'">
          {{ formatPercent(data?.nft_data?.change_1d_percent) }}
        </span>
      </div>
      <div class="Pon-Popup__balance">{{ data?.nft_data?.floor_price_eth?.toFixed(2) }}</div>
    </div>
    <div class="Pon-Popup__privileges">
      <div class="Pon-Popup__title">
        <StarsIcon /> Привилегии PoN
      </div>
      <div class="Pon-Popup__list">
        <div class="Pon-Popup__item">
          <div class="Pon-Popup__icon">
            <DropIcon class="Pon-Popup__icon--drop" />
          </div>
          Полный доступ к Drops Capital
        </div>
        <div class="Pon-Popup__item">
          <div class="Pon-Popup__icon">
            <DropIcon class="Pon-Popup__icon--drop" />
          </div>
          Лучшие раунды для комьюнити
        </div>
        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxODkyMjYzODQ1" target="_blank">
          <div class="Pon-Popup__icon">
            <img
              :src="require(`@/Groups/Pon/private/media/images/icon-ponchat1.png`)"
              class="Pon-Popup__icon--pon-chat"
              alt="pon"
            />
          </div>
          Основной чат сообщества
        </a>
        <a class="Pon-Popup__item Pon-Popup__item--hover" href="https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAyMjU4MTM0NDc1" target="_blank">
          <div class="Pon-Popup__icon">
            <img
              :src="require(`@/Groups/Pon/private/media/images/icon-ponchat2.png`)"
              class="Pon-Popup__icon--pon-chat"
              alt="pon"
            />
          </div>
          Мем-трейдинг чат
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  //--------------------------
  import StarsIcon from '@/Groups/Pon/private/svg/StarsIcon.vue';
  import DropIcon from "@/Groups/Pon/private/svg/DropIcon.vue";
  //--------------------------
  const store = useStore();
  //--------------------------
  const data = computed(() => store.state.Pon.ponData);

  const formatPercent = (value) => {
    if (value === null || value === undefined || isNaN(value)) return '0%';
    let num = Number(value);
    if (num > 0 && num < 0.01) {
      num = 0.01;
    } else if (num < 0 && num > -0.01) {
      num = -0.01;
    }
    const rounded = Math.abs(num).toFixed(2);
    const sign = num > 0 ? '+' : num < 0 ? '−' : '';
    return `${sign}${rounded}%`;
  };
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
